import { useState } from "react";
import { useParams } from "react-router-dom";
import { AuthService } from "services/authService";
import { useHistory } from "react-router-dom";

export const useRegisterSkolFederationen = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(false);

  const params = useParams();
  const { activationToken } = params as any;

  const handleRegister = async (entityId: string) => {
    const result = AuthService.registerWithSkolFed(activationToken, entityId);
    return result;
  };

  return { handleRegister, isLoading, authError };
};
